<template>
  <div class="device_list" v-loading="loading">
    <div class="s_wrapper">
      <el-select class="s_input" v-model="storeId" placeholder="选择所属门店" @change="onSearch" clearable>
        <el-option v-for="item in options" :key="item.storeId" :label="item.storeName" :value="item.storeId"></el-option>
      </el-select>
      <el-select class="s_input" v-model="sourceType" placeholder="设备来源" @change="onSearch" clearable>
        <el-option label="总部分配" value="1"></el-option>
        <el-option label="自行购买" value="2"></el-option>
      </el-select>
      <el-input class="s_input" v-model="equipmentName" suffix-icon="el-icon-search" placeholder="请输入设备名称" @change="onSearch" clearable></el-input>
      <el-input class="s_input" v-model="modelNumber" suffix-icon="el-icon-search" placeholder="请输入设备型号" @change="onSearch" clearable></el-input>
      <el-input class="s_input" v-model="brand" suffix-icon="el-icon-search" placeholder="请输入设备品牌" @change="onSearch" clearable></el-input>
      <!-- <el-button class="btn" type="primary" plain>导出</el-button> -->
      <el-button class="btn" type="primary" @click="handleShow(1)">新增</el-button>
    </div>

    <div class="g_table">
      <el-table :data="tableData" style="width: 100%" max-height="540">
        <el-table-column label="序号" show-overflow-tooltip width="80">
          <template slot-scope="scope">
            {{ scope.$index + 1 + (currentPage - 1) * pageSize }}
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip prop="modelNumber" label="型号"></el-table-column>
        <el-table-column show-overflow-tooltip prop="equipmentName" label="设备名称"></el-table-column>
        <el-table-column show-overflow-tooltip prop="sourceType " label="设备来源">
          <template slot-scope="scope">
            <span v-if="scope.row.sourceType == 1">总部分配</span>
            <span v-if="scope.row.sourceType == 2">自行购买</span>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip prop="brand" label="品牌"></el-table-column>
        <el-table-column show-overflow-tooltip prop="employCount" label="数量" width="100"></el-table-column>
        <el-table-column show-overflow-tooltip prop="introduce" label="设备简介"></el-table-column>
        <el-table-column show-overflow-tooltip prop="storeName" label="所属门店"></el-table-column>
        <el-table-column show-overflow-tooltip prop="contactDate" label="生产日期"></el-table-column>
        <el-table-column show-overflow-tooltip label="操作" header-align="center" align="center" width="220">
          <template slot-scope="scope">
            <el-button type="primary" plain @click="handleShow(2, scope.row)">修改</el-button>
            <el-button type="danger" plain @click="handleDel(scope.row.id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageSize" :page-sizes="pageSizeArr" layout="prev, pager, next, jumper, sizes, total" :total="totalItemsCount"></el-pagination>

    <el-dialog :title="isAdd ? '新增' : '修改'" :visible.sync="dialogVisible">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="120px" class="ruleForm">
        <el-row type="flex" justify="space-around">
          <el-col :span="10">
            <el-form-item label="设备型号" prop="modelNumber">
              <el-input v-model="ruleForm.modelNumber" placeholder="请输入设备型号"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="设备名称" prop="equipmentName">
              <el-input v-model="ruleForm.equipmentName" placeholder="请输入设备名称"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row type="flex" justify="space-around">
          <el-col :span="10">
            <el-form-item label="设备品牌" prop="brand">
              <el-input v-model="ruleForm.brand" placeholder="请输入设备品牌"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="添加数量" prop="employCount">
              <el-input-number v-model="ruleForm.employCount" @change="handleStepperChange" :min="1"></el-input-number>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row type="flex" justify="space-around">
          <el-col :span="10">
            <el-form-item label="所属门店" prop="storeName">
              <el-select class="s_input" v-model="ruleForm.storeName" placeholder="选择所属门店" @change="changeShop">
                <el-option v-for="item in options" :key="item.storeId" :label="item.storeName" :value="item.storeId"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="生产日期" prop="contactDate">
              <el-date-picker v-model="ruleForm.contactDate" type="date" placeholder="选择日期" value-format="yyyy-MM-dd"></el-date-picker>
              <!-- <el-date-picker v-model="ruleForm.contactDate" type="datetime" placeholder="选择日期" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker> -->
            </el-form-item>
          </el-col>
        </el-row>
        <el-row type="flex" justify="space-around">
          <el-col :span="10">
            <el-form-item label="设备来源" prop="sourceType">
              <el-select class="s_input" v-model="ruleForm.sourceType" placeholder="选择设备来源" @change="changeSourceType">
                <el-option label="总部分配" value="1"></el-option>
                <el-option label="自行购买" value="2"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="10"></el-col>
        </el-row>
        <el-row type="flex" justify="space-around">
          <el-col :span="22">
            <el-form-item label="设备简介" prop="introduce">
              <el-input v-model="ruleForm.introduce" type="textarea" :rows="4" placeholder="请输入设备简介"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <span slot="footer">
        <el-button @click="onCancel">取 消</el-button>
        <el-button type="primary" @click="onSubmit('ruleForm')" :loading="submitLoding">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
function createInitRuleForm() {
  return {
    brand: "", // 品牌
    contactDate: "", // 生产日期
    employCount: "", // 数量
    equipmentName: "", // 名称
    introduce: "", // 简介
    modelNumber: "", // 设备型号
    sourceType: "", // 来源：1总部分配；2自行购买
    storeName: "", // 所属门店name
    storeId: "", // 所属门店id
  }
}
export default {
  data() {
    return {
      loading: false,
      tableData: [],
      options: [],
      storeId: "",
      sourceType: "",
      equipmentName: "",
      modelNumber: "",
      brand: "",
      isAdd: false,
      dialogVisible: false,
      submitLoding: false,
      ruleForm: createInitRuleForm(),
      rules: {
        modelNumber: [{ required: true, message: "请输入设备型号", trigger: "blur" }],
        equipmentName: [{ required: true, message: "请输入设备名称", trigger: "blur" }],
        brand: [{ required: true, message: "请输入设备品牌", trigger: "blur" }],
        employCount: [{ required: true, message: "请输入设备数量", trigger: "blur" }],
        introduce: [{ required: true, message: "请输入设备简介", trigger: "blur" }],
        storeName: [{ required: true, message: "请选择所属门店", trigger: "change" }],
        sourceType: [{ required: true, message: "请选择设备来源", trigger: "change" }],
        contactDate: [{ required: true, message: "请选择生产日期", trigger: "blur" }],
      },

      currentPage: 1, // 当前页码
      pageSize: 10, // 每页显示的行数
      pageSizeArr: [10, 20, 50], // 每页显示的行数(可选)
      totalItemsCount: 0, // 总记录数（需要从后端获取）
    }
  },
  created() {
    this.getList()
    this.getShopList()
  },
  methods: {
    // 设备列表
    getList() {
      this.loading = true
      this.$axios
        .get(this.$api.equipmentInfoselect, {
          params: {
            brand: this.brand, // 品牌
            storeId: this.storeId, // 所属门店id
            sourceType: this.sourceType, // 来源：1总部分配；2自行购买
            equipmentName: this.equipmentName, // 名称
            modelNumber: this.modelNumber, // 设备型号
            page: this.currentPage, // 页码数
            pageSize: this.pageSize, // 每页数量
          },
        })
        .then(res => {
          this.tableData = res.result.list
          this.totalItemsCount = res.result.totalCount
          this.loading = false
        })
        .catch(err => {
          this.loading = false
          this.$message.error(err.desc)
        })
    },
    // 门店列表
    getShopList() {
      this.$axios
        .get(this.$api.selectStoreInfoList, {
          params: {
            page: 1, // 页码数
            pageSize: 9999, // 每页数量
          },
        })
        .then(res => {
          this.options = res.result.list
        })
        .catch(err => {
          this.$message.error(err.desc)
        })
    },
    handleShow(val, row) {
      if (val == 1) {
        this.isAdd = true
      } else {
        this.isAdd = false
        this.ruleForm = Object.assign({}, row)
      }
      this.dialogVisible = true
    },
    handleDel(id) {
      this.$confirm("即将删除该设备，是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$axios
            .post(`${this.$api.equipmentInfodelete}/${id}`)
            .then(res => {
              this.$message.success("删除成功")
              this.getList()
            })
            .catch(err => {
              this.$message.error(err.desc)
            })
        })
        .catch(() => {})
    },
    changeShop(e) {
      this.ruleForm.storeId = e
    },
    changeSourceType(e) {
      this.ruleForm.sourceType = e
    },
    // 搜索
    onSearch() {
      this.tableData = []
      this.currentPage = 1
      this.getList()
    },
    onSubmit(formName) {
      let params = Object.assign({}, this.ruleForm)
      let api = ""
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (this.isAdd) {
            // 新增
            api = this.$api.equipmentInfoinsert
          } else {
            // 修改
            api = this.$api.equipmentInfoupdate
          }
          this.$axios
            .post(api, params)
            .then(res => {
              this.$message.success(`设备${this.isAdd ? "添加" : "修改"}成功`)
              this.resetForm()
              this.dialogVisible = false
              this.getList()
            })
            .catch(err => {
              this.$message.error(err.desc)
            })
        } else {
          this.$message.error("提交失败，填写内容不完整")
          return false
        }
      })
    },
    handleStepperChange(e) {
      this.ruleForm.employCount = e
    },
    onCancel() {
      this.resetForm()
      this.dialogVisible = false
    },
    // 切换每页显示的条数
    handleSizeChange(e) {
      this.tableData = []
      this.pageSize = e
      this.getList()
    },
    // 换页
    handleCurrentChange(e) {
      this.tableData = []
      this.currentPage = e
      this.getList()
    },
    // 重置校验
    resetForm() {
      this.ruleForm = createInitRuleForm()
      this.$refs.ruleForm.resetFields()
    },
  },
}
</script>

<style scoped lang="scss">
.device_list {
  .ruleForm {
    .picurl {
      width: 100px;
      height: 100px;
      border-radius: 6px;

      &:not(:first-child) {
        margin-left: 16px;
      }
    }

    ::v-deep .el-input-number,
    ::v-deep .el-select,
    ::v-deep .el-input,
    ::v-deep .el-input__inner {
      width: 100%;
    }
  }
}
</style>
